// Confirmation for destructive actions. Wording is in src/lang under
// `confirm.<key>` ({ title, message }); okKey is the red button's label key.
export function confirmDanger (vm, key, params, okKey = 'buttons.remove') {
  return vm.$bvModal.msgBoxConfirm(vm.$t(`confirm.${key}.message`, params), {
    title: vm.$t(`confirm.${key}.title`, params),
    okTitle: vm.$t(okKey),
    okVariant: 'danger',
    cancelTitle: vm.$t('buttons.cancel'),
    cancelVariant: 'outline-secondary',
    autoFocusButton: 'cancel',
    centered: true
  }).then(choice => choice === true)
}
